<div class="m-0 p-0" (click)="open(modalConfirmDeletion, { size: 'md', centered: true })">
    <fa-icon [icon]="icon" [styles]="styles"> </fa-icon>
    &nbsp;
</div>
<ng-template #modalConfirmDeletion let-modal>
    <div class="modal-header border-0 pb-0">
        <h5 class="modal-title">Quitar producto del pedido</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body pt-2">
        ¿Está seguro que desea quitar <strong>{{ itemName }}</strong> del pedido?
    </div>
    <div class="modal-footer border-0 pt-0">
        <button class="btn btn-outline-secondary" type="button" (click)="modal.close('Close Click')">Cancelar</button>
        <button class="btn btn-purple-soft" type="button" (click)="onConfirm(params)">Confirmar</button>
    </div>
</ng-template>
